// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorCart_wrapper__eeB19"};